import {
  createContactDtoSchema,
  createContactListDtoSchema,
  createContactListResponseSchema,
  createContactResponseSchema,
  deleteContactResponseSchema,
  getContactResponseSchema,
  listContactsResponseSchema,
  updateContactRequestSchema,
  updateContactResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

// Extend request objects only for the frontend with necessary path params
const CRUD = {
  c: createContactDtoSchema,
  r: z.object({ contactId: z.string() }),
  u: updateContactRequestSchema.extend({ contactId: z.string() }),
  d: z.object({ contactId: z.string() }),
};

const endpoints = {
  'contacts.create': {
    method: 'POST',
    url: `${API_URL_BASE}contacts`,
    requestSchema: CRUD.c,
    responseSuccessSchema: createContactResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof CRUD.c,
    typeof createContactResponseSchema,
    z.ZodUndefined
  >,
  'contacts.create.many': {
    method: 'POST',
    url: `${API_URL_BASE}contacts/many`,
    requestSchema: createContactListDtoSchema,
    responseSuccessSchema: createContactListResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof createContactListDtoSchema,
    typeof createContactListResponseSchema,
    z.ZodUndefined
  >,
  'contacts.delete': {
    method: 'DELETE',
    url: `${API_URL_BASE}contacts/:contactId`,
    requestSchema: CRUD.d,
    responseSuccessSchema: deleteContactResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof CRUD.d,
    typeof deleteContactResponseSchema,
    z.ZodUndefined
  >,
  'contacts.get': {
    method: 'GET',
    url: `${API_URL_BASE}contacts/:contactId`,
    requestSchema: CRUD.r,
    responseSuccessSchema: getContactResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof CRUD.r,
    typeof getContactResponseSchema,
    z.ZodUndefined
  >,
  'contacts.get.all': {
    method: 'GET',
    url: `${API_URL_BASE}contacts`,
    requestSchema: z.undefined(),
    responseSuccessSchema: listContactsResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof listContactsResponseSchema,
    z.ZodUndefined
  >,
  'contacts.update': {
    method: 'PUT',
    url: `${API_URL_BASE}contacts/:contactId`,
    requestSchema: CRUD.u,
    responseSuccessSchema: updateContactResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    typeof CRUD.u,
    typeof updateContactResponseSchema,
    z.ZodUndefined
  >,
};

export default endpoints;
